import { useStoreState } from 'easy-peasy'
import React from 'react'
import styled from 'styled-components'
import { useTranslations } from '../../utils/Text'
import Image from './Image'
import Dropdown from './Dropdown'

const Container = styled.div`
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  min-height: 57px;
  margin: ${props => props.margin}px;
  a:focus {
    outline: none;
    box-shadow: none;
    cursor: unset;
  }
`

export default function Header({ config }) {
  const { logo, alt, margin, maxWidth } = config
  const dropdown = useStoreState(state => state.dropdown)
  const imgToShow = useTranslations(logo, {})
  const locale = useStoreState(state => state.locale.locale)

  const LOCALE = {
    country: locale === 'notAllowed', // used for IT until: https://jira.isdin.com/browse/LIC-493
  }

  return (
    <>
      <Container margin={margin}>
        <div className="align-self-center">
        {/* eslint-disable-next-line */}
          <a href="#">
            <Image src={imgToShow} alt={alt} maxWidth={maxWidth} />
          </a>
        </div>
        {!LOCALE.country && (
          <Dropdown tabIndex="-1" options={dropdown} />
        )}
      </Container>
    </>
  )
}
